import { WorkerMessage, WorkerMessageType, ViewerFragmentFragment } from '@amber-ui/core';

const urlB64ToUint8Array = (base64String: string): Uint8Array => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');

  const rawData = atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; i += 1) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

let newWorker: ServiceWorker | null = null;
let registration: ServiceWorkerRegistration | null = null;

if (navigator && navigator.serviceWorker && process.env.NODE_ENV === 'production') {
  void navigator.serviceWorker.register('/index.js').then((r) => {
    registration = r;
    if (registration) {
      registration.addEventListener('updatefound', (): void => {
        newWorker = (registration as ServiceWorkerRegistration).installing;
        if (newWorker) {
          const installingWorker = newWorker;
          installingWorker.addEventListener('statechange', () => {
            switch (installingWorker.state) {
              case 'installed':
                if (navigator.serviceWorker.controller) {
                  // new update available
                  // oxlint-disable-next-line unicorn/require-post-message-target-origin -- ServiceWorker.postMessage doesn't accept targetOrigin
                  installingWorker.postMessage({ message_type: 'skip_waiting' });
                }
                // No update available
                break;
            }
          });
        }
      });
    }
  });
}
export const sendMessage = (message: WorkerMessage): Promise<void> => {
  if (!registration) {
    return Promise.resolve();
  }
  const worker = registration.active;
  if (worker) {
    // oxlint-disable-next-line unicorn/require-post-message-target-origin -- ServiceWorker.postMessage doesn't accept targetOrigin
    worker.postMessage(message);
  }
  return Promise.resolve();
};

export const setServiceWorkerViewer = async (
  viewer: ViewerFragmentFragment,
  propagate: boolean
) => {
  if (!registration) {
    return;
  }
  if (Notification && 'PushManager' in window) {
    Notification.requestPermission().then(
      async (permission) => {
        if (!registration) {
          return;
        }
        if (permission === 'granted') {
          let subscription = await registration.pushManager.getSubscription();
          if (!subscription) {
            subscription = await registration.pushManager.subscribe({
              // tsgo 7.0 requires explicit BufferSource assertion here — Uint8Array is a subtype
              // of BufferSource but the PushSubscriptionOptionsInit overload doesn't narrow it.
              applicationServerKey: urlB64ToUint8Array(
                window['app_config'].web_push_public_key || ''
              ) as BufferSource,
              userVisibleOnly: true,
            });
          }
          await fetch(`${window['app_config'].api_host_name}/updateWebPush`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/zip,*/*',
              Authorization: `Bearer ${viewer.token}`,
            },
            body: JSON.stringify({ user_id: viewer.user_id, subscription: subscription.toJSON() }),
          });
        }
      },
      () => {}
    );
  }

  await sendMessage({
    message_type: WorkerMessageType.auth,
    payload: { viewer, propagate },
  });
};
